import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

import { getLocalStorageItem } from '@/utils/localStorage';

import { JournalFilterType } from './journal.types';

class JournalStore {
  lastJournalPanelVisit: string | null;
  journalFilter: JournalFilterType;
  showHistory = true;

  constructor() {
    this.lastJournalPanelVisit =
      getLocalStorageItem('lastJournalPanelVisit') ?? null;
    this.journalFilter =
      (getLocalStorageItem('journalFilter') as JournalFilterType) ??
      JournalFilterType.SHOW_ALL;
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'journalStore',
      properties: ['lastJournalPanelVisit', 'journalFilter'],
      storage: window.localStorage,
    });
  }

  setLastJournalPanelVisit(v: string | null) {
    this.lastJournalPanelVisit = v;
  }
  setJournalFilter(v: JournalFilterType) {
    this.journalFilter = v;
  }
  toggleShowHistory() {
    this.showHistory = !this.showHistory;
  }
  setShowHistory(v: boolean) {
    this.showHistory = v;
  }
}

export const journalStore = new JournalStore();
